import React from 'react'
import IconButton from './IconButton';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import clsx from 'clsx';


function WarningRoundedButton(
    {
        tooltip,
        className,
        ...props
    }) {
    return <IconButton
        tooltip={tooltip}
        Icon={WarningRoundedIcon}
        className={clsx(className)
        }
        {...props}
    />
}

export default WarningRoundedButton;